import { ApiMap } from '../ApiMap';
import { createApiCache, MAX_CACHE_TIMEOUT } from './createApiCache';
const EmbedCache = {};
export function getFetchOEmbedProxy(http) {
  const withEmbedCache = createApiCache(http.get, ApiMap.OEMBED_PROXY.getUrl, EmbedCache, MAX_CACHE_TIMEOUT);
  return function fetchOEmbedProxy(url) {
    const httpParams = {
      query: {
        url
      }
    };
    return withEmbedCache('', httpParams);
  };
}